// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';
import { Support, SupportType } from '../../../types/Model';

export interface CreateNewSupportRequestPayload {
  message: string;
  imagesFiles?: File[];
  title: string;
  supportType: SupportType;
}

export interface CreateNewSupportSuccessPayload {
  data: Support;
}

export interface CreateNewSupportFailPayload {
  error: Error;
}

const createNewSupportActions = createAsyncAction(
  'elearning/CREATE_NEW_SUPPORT_DATA',
  'elearning/CREATE_NEW_SUPPORT_DATA_SUCCESS',
  'elearning/CREATE_NEW_SUPPORT_DATA_FAIL'
)<
  CreateNewSupportRequestPayload,
  CreateNewSupportSuccessPayload,
  CreateNewSupportFailPayload
>();

export { createNewSupportActions as default }
